import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  Testimoni,
  TESTIMONI_DURATION_SECOND,
} from '@merchant-portal/app/models/testimoni/testimoni.interface';
import { testimonies as testimoniData } from './testimonies';

@Component({
  selector: 'app-testimonial',
  imports: [CommonModule],
  templateUrl: './testimonial.component.html',
  styleUrl: './testimonial.component.scss',
})
export class TestimonialComponent implements OnInit, OnDestroy {
  currentTestimonialIndex = 0;
  testimonies = [...testimoniData, testimoniData[0]];
  private slideInterval: any;
  isVisible = true;

  ngOnInit() {
    this.startAutoSlide();
  }

  ngOnDestroy() {
    if (this.slideInterval) {
      clearInterval(this.slideInterval);
    }
  }

  private startAutoSlide() {
    this.slideInterval = setInterval(() => {
      this.nextTestimonial();
    }, TESTIMONI_DURATION_SECOND);
  }

  nextTestimonial() {
    this.isVisible = false;

    setTimeout(() => {
      if (this.currentTestimonialIndex == testimoniData.length - 1) {
        this.currentTestimonialIndex = 0;
      } else {
        this.currentTestimonialIndex++;
      }

      setTimeout(() => {
        this.isVisible = true;
      }, 50);
    }, 400);
  }

  get currentTestimonial(): Testimoni {
    return this.testimonies[this.currentTestimonialIndex];
  }
}
